import angular from 'angular';

angular
  .module('cloudX')
  .controller('StringInputDialogCtrl', [
    '$scope',
    '$element',
    'appMessages',
    'close',
    'title',
    'message',
    'placeholder',
    'value',
    stringInputDialogCtrl,
  ]);

function stringInputDialogCtrl(
  $scope,
  $element,
  appMessages,
  close,
  title,
  message,
  placeholder,
  value,
) {
  $scope.title = appMessages(title);
  $scope.message = appMessages(message);
  $scope.placeholder = appMessages(placeholder);
  $scope.value = value || '';
  $scope.save = function(result) {
    if (!$scope.value) return;
    $element.modal('hide');
    close($scope.value, 500);
  };
  $scope.close = function(result) {
    $element.modal('hide');
    close(null, 500);
  };
}
